import { render, staticRenderFns } from "./ShippingAddressItem.vue?vue&type=template&id=97fb4f8c&scoped=true&"
import script from "./ShippingAddressItem.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressItem.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddressItem.vue?vue&type=style&index=0&id=97fb4f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fb4f8c",
  null
  
)

export default component.exports